/* istanbul ignore file */
import React, { SVGProps } from 'react';

import css from 'styles/components/sephora/icons.scss';

function SephoraBIIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg key={Math.random()} x="0" y="0" viewBox="0 0 44 44" xmlSpace="preserve" width="75px" height="75px" {...props}>
      <path className={css.sephoraIcon} d="M44 21.3C43.7 9.8 34.3.4 22.7 0 10-.4-.4 10 0 22.7.4 34.2 9.7 43.6 21.3 44 34 44.4 44.4 34 44 21.3z" />
      <path
        className={css.sephoraIcon}
        d="M36 27c-1.2 3.7-5.2 7.7-8.9 8.9-8.4 2.8-16.2-1.7-18.9-8.7 10.1-2.3 9.3-14.1 9.3-14.1s1.1 3.5.3 7.1c8.5-.2 10.8-6.9 11.4-11 .1 0 .1.1.1.1.7 3.3 2.4 7.4 6.9 9.2.8 2.6.7 5.5-.2 8.5z"
      />
      <path
        d="M36.3 18.4c-4.4-1.7-6.2-5.9-6.9-9.2-.1 0-.1-.1-.1-.1-.6 4.2-3 10.9-11.4 11 .7-3.6-.3-7.1-.3-7.1s.7 12-9.4 14.3c2.7 7 10.5 11.5 18.9 8.7 3.7-1.2 7.7-5.3 8.9-8.9.9-3.1 1-6 .3-8.7zM25.1 32.6c-.6.3-1.2.6-1.9.7h-.1c-1.7.3-3.5-.1-4.8-1.1l-1-.7v-.1h.3c1 .1 2-.2 2.8-.8.2-.2.4-.2.7-.2.4 0 .7.2.9.4.2-.3.5-.4.9-.4.2 0 .5.1.7.2.8.6 1.8 1 2.8.8h.3v.1l-1.6 1.1zm6-10.5c.2 1 .7 2 2.5 2.2-.6.1-2.8-.4-4.4-1.7.2 1.1.7 2.2 2 2.6-.7 0-2.6-1-3.8-2.6-.1 1 .1 2.2 1.2 2.9v.1c-3.5-2.1-3.8-4.5-4-4.9l.3-.1c1.4 2.3 5.9 1.7 6.7-.1.1.1.9 2.2 4 2.3h.1c-.6.3-2.9.2-4.6-.7z"
        fill="#fff"
      />
      <path
        className={css.sephoraIcon}
        d="M26.9 31.4h-.3c-1 .1-2-.2-2.8-.8-.2-.2-.4-.2-.7-.2-.4 0-.7.2-.9.4-.1-.1-.2-.3-.4-.4-.2-.1-.3-.1-.5-.1-.3 0-.5.1-.7.2-.8.6-1.8 1-2.8.8h-.3v.1l1 .7c1.4 1 3.2 1.5 4.8 1.1h.1c.6-.1 1.3-.4 1.9-.7l1.6-1.1zm8.8-8.6c-3.1-.1-3.9-2.2-4-2.3-.9 1.8-5.4 2.4-6.8.1l-.3.1c.2.5.5 2.9 4 4.9-1-.7-1.2-1.8-1.2-2.9 1.2 1.6 3.1 2.6 3.8 2.6-1.3-.4-1.8-1.6-2-2.6 1.5 1.3 3.7 1.8 4.4 1.7-1.8-.2-2.2-1.1-2.5-2.2 1.7.8 4 .9 4.6.6z"
      />
    </svg>
  );
}

export default SephoraBIIcon;
